module.exports = __webpack_public_path__ + "img/managertips_md.0f48e817.png";